import React from 'react';
import { PropertyGrid, TextInput } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import Model from './EnvironmentColorizer';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function EnvironmentColorizerEditor(props) {
  const {
    value
  } = props;
  const onModelChange = useValueChange(Model, props);
  return /*#__PURE__*/_jsxs(PropertyGrid, {
    children: [/*#__PURE__*/_jsx(PropertyGrid.Item, {
      label: "Indoor Color",
      children: /*#__PURE__*/_jsx(TextInput, {
        value: Model.getIndoorColor(value),
        onChange: onModelChange,
        eventData: "setIndoorColor"
      })
    }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
      label: "Outdoor Color",
      children: /*#__PURE__*/_jsx(TextInput, {
        value: Model.getOutdoorColor(value),
        onChange: onModelChange,
        eventData: "setOutdoorColor"
      })
    }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
      label: "Fallback Color",
      children: /*#__PURE__*/_jsx(TextInput, {
        value: Model.getUnsetColor(value),
        onChange: onModelChange,
        eventData: "setUnsetColor"
      })
    })]
  });
}